/** @format */

import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import { useEffect, useState } from 'react';
dayjs.extend(minMax);
function useCalculateDate(appDateRange, callback = () => {}) {
  const [dateRange, setDateRange] = useState();
  function calculateDateRange() {
    if (!Array.isArray(appDateRange)) return;
    const { startDate, endDate } = appDateRange[0];
    const pageEnd = dayjs.min(dayjs(endDate), dayjs());
    const pageStart = dayjs.max(dayjs(startDate), pageEnd.subtract(90, 'day'));
    const init = {
      startDate: pageStart.toDate(),
      endDate: pageEnd.toDate(),
      key: 'selection',
    };
    callback([init]);
    setDateRange(init);
  }
  useEffect(calculateDateRange, [appDateRange]);
  return dateRange;
}

export default useCalculateDate;

/**
 * Same as useCalculateDate but not a hook,
 * Returns a date range object with a 90-day window
 */
export function goPastInDate(dateRange, isCY = false) {
  if (!Array.isArray(dateRange) || dateRange.length === 0) {
    throw new Error('Invalid date range provided:[goPastInDate]');
  }
  const { startDate, endDate, endDateCY } = dateRange[0];
  const effectiveEndDate = isCY && endDateCY ? endDateCY : endDate;
  const pageEnd = dayjs.min(dayjs(effectiveEndDate), dayjs());
  const pageStart = dayjs.max(dayjs(startDate), pageEnd.subtract(90, 'day'));
  return [
    {
      startDate: pageStart.toDate(),
      endDate: pageEnd.toDate(),
      endDateCY: endDateCY || undefined,
      key: 'selection',
    },
  ];
}
